import type { SVGProps } from 'react';

const Upload04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 22c5.5228 0 10-4.4772 10-10 0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 5.5228 4.4771 10 10 10Z"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m16 12-4-4m0 0-4 4m4-4v9.2c0 1.3907 0 2.0861.5505 2.8646.3658.5173 1.4189 1.1557 2.0467 1.2408.9449.128 1.3037-.0592 2.0214-.4335C19.8167 19.2036 22 15.8568 22 12c0-5.5229-4.4772-10-10-10C6.4771 2 2 6.4771 2 12c0 3.7014 2.011 6.9331 5 8.6622"
    />
  </svg>
);

export default Upload04;
